<template>
  <sl-page>
    <div class='page-filter'>
      <Row :gutter="12">
        <Col span="6" :lg="6" :md="8" :sm="8" :xs="24" class="margin-bottom">
        <Input v-model="params.name" placeholder="请输入名称搜索"></Input>
        </Col>
        <Col span="18" :lg="18" :md="16" :sm="16" :xs="24" class="page-action">
        <div>
          <Button type="primary" icon="ios-search" @click="list()">搜索</Button>
        </div>
        <div>
          <Button type="primary" class="margin-right" icon="md-add"" @click=" create()">新增计费规则</Button>
          <!-- <Button :disabled="removeDisable" type="error" icon="md-trash" @click="remove()">删除</Button> -->
        </div>
        </Col>
      </Row>
    </div>
    <div class="pg-bd">
      <sl-table ref="table" :loading="loading" :page="page" :columns="columns" :data="data" @on-selection-change="handleSelect" @on-update="handleChange"></sl-table>
    </div>
    <add ref="item" @on-update="handleUpdate"></add>
    <info ref="detail"></info>
  </sl-page>
</template>
<script>
import add from './add'
import info from './info'

let ruleStateData = [{
  value: 0,
  label: '有效（上线）'
}, {
  value: 1,
  label: '无效（下线）'
}]
let clearingTypeData = [{
  value: 1,
  label: '日结算'
}, {
  value: 2,
  label: '周结算'
}, {
  value: 3,
  label: '月结算'
}, {
  value: 4,
  label: '季度结算'
}, {
  value: 5,
  label: '半年结算'
}, {
  value: 6,
  label: '周年结算'
}]

export default {
  components: { add, info },
  data() {
    return {
      ruleStateData: ruleStateData,
      clearingTypeData: clearingTypeData,
      columns: [{
          title: '序号',
          type: 'index',
          width: 65,
          align: 'center'
        },
        {
          title: '名称',
          key: 'name'
        },
        {
          title: '金融公司',
          key: 'companyName'
        },
        {
          title: '结算方式',
          key: 'clearingType',
          render: (h, params) => {
            let txt = this.cycleText(params.row.clearingType)
            return h('div', txt)
          }
        },
        {
          title: '每期费用',
          key: 'stagesPrice'
        },
        {
          title: '分期数',
          key: 'stagesNum'
        },
        {
          title: '状态',
          key: 'state',
          render: (h, params) => {
            let txt = this.stateText(params.row.state)
            return h('div', txt)
          }
        },
        {
          title: '操作',
          key: 'action',
          width: 150,
          align: 'center',
          render: (h, params) => {
            let btnSee = h('a', {
              props: {
                type: 'primary',
                size: 'small'
              },
              style: {
                marginRight: '5px'
              },
              on: {
                click: () => {
                  this.detail(params)
                }
              }
            }, '查看')
            let btnStart = h('a', {
              props: {
                type: 'primary',
                size: 'small'
              },
              style: {
                marginRight: '5px'
              },
              on: {
                click: () => {
                  this.updateState(params.row)
                }
              }
            }, '启用')
            let btnStop = h('a', {
              props: {
                type: 'primary',
                size: 'small'
              },
              style: {
                marginRight: '5px'
              },
              on: {
                click: () => {
                  this.updateState(params.row)
                }
              }
            }, '禁用')
            let btnArr = []
            if (params.row.state) {
              btnArr.push(btnSee, btnStart)
            } else {
              btnArr.push(btnSee, btnStop)
            }
            return h('div', btnArr)
          }
        }
      ],
      data: [],
      params: {
        name: ''
      },
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      loading: false,
      modalVisible: false,
      selection: [],
      financeData: [],
      cycleData: []

    }
  },
  computed: {
    removeDisable() {
      return this.selection.length == 0
    }
  },
  created() {
    this.cycle()
  },
  mounted() {
    this.list()
  },

  methods: {

    list() {
      let params = { search: { ...this.params }, pageSize: this.page.pageSize, pageNum: this.page.pageNum }
      this.loading = true
      this.$request.ruleQuery(params).then(resp => {
        this.loading = false
        if (!resp.code) {
          let listData = resp.data.list.reverse()
          this.data = this.$utils.conv(listData || [])
          this.page.total = resp.data.total || 0
        }
      })
    },

    detail({ row }) {
      // this.modalVisible = true
      this.detailModalShow(row)
    },

    create() {
      // this.modalVisible = true
      this.addModalShow()
    },

    remove() {
      let params = { ids: this.selection }
      this.$ui.confirm(this.$request.roleDeleteBatch, '确定删除角色？')(params).then(resp => {
        if (!resp.code) {
          this.$Message.success('删除成功')
          this.selection = []
          this.list()
        }
      })
    },

    handleUpdate() {
      this.modalVisible = false
      this.list()
    },

    handleChange(pageNum, pageSize) {
      if (this.page.pageNum != pageNum || this.page.pageSize != pageSize) {
        this.page.pageNum = pageNum
        this.page.pageSize = pageSize
        this.list()
      }
    },

    handleSelect(selection) {
      this.selection = selection.map(i => i.id)
    },

    $update() {
      this.list()
    },

    addModalShow() {
      this.$refs['item'].show()
    },

    detailModalShow(row) {
      this.$refs['detail'].show()
      this.$refs['detail'].detail(row.id)
    },

    updateState(obj) {
      let params = obj.id
      let tip = obj.state ? '确定启用吗？' : '确定禁用吗？'
      let msg = obj.state ? '启用成功' : '禁用成功'
      this.$ui.confirm(this.$request.ruleUpdateState, tip)(params).then(resp => {
        if (!resp.code) {
          this.$Message.success(msg)
          this.list()
        }
      })
    },

    finance() {
      this.$request.ruleKV('finance').then(resp => {
        this.financeData = resp.data || []
      })
    },

    cycle() {
      this.$request.ruleKV('cycle').then(resp => {
        this.cycleData = resp.data || []
      })
    },

    cycleText(key) {
      let str = ''
      this.cycleData.forEach(item => {
        if (String(item.cKey) === String(key)) {
          str = item.cValue
        }
      })
      return str
    },

    stateText(key) {
      let str = ''
      this.ruleStateData.forEach(item => {
        if (String(item.value) === String(key)) {
          str = item.label
        }
      })
      return str
    }


  }
}

</script>
